<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";

  .modal-header-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: colors.get(primary_50);
    width: calc(100% + utils.in_rem(32px));
    margin: utils.in_rem(-16px);
    padding: utils.in_rem(16px) utils.in_rem(24px);
    box-sizing: border-box;

    .title {
      @include colors.color(textWhite);
    }
  }

  .body {
    display: flex;
    padding: utils.in_rem(24px) utils.in_rem(32px);
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    gap: utils.in_rem(24px);
    border-bottom: utils.in_rem(1px) solid colors.get(interfaceSwGrey_10);
  }

  .footer {
    display: flex;
    padding: utils.in_rem(24px) utils.in_rem(24px) utils.in_rem(12px)
      utils.in_rem(24px);
    justify-content: flex-end;
    align-items: center;
    gap: utils.in_rem(17px);
    align-self: stretch;
  }
</style>

<script>
  import { showToast } from "@sourcewhale/shared/src/assets/js/src/general/utils";
  import { ToastError } from "@sourcewhale/shared/src/svelte/api/sw-toast-error";
  import { assignToDoContact } from "@sourcewhale/shared/src/svelte/api/todos";
  import Button from "@sourcewhale/shared/svelte-design-system/components/atoms/Button.svelte";
  import CloseButton from "@sourcewhale/shared/svelte-design-system/components/molecules/Modal/CloseButton.svelte";
  import Modal from "@sourcewhale/shared/svelte-design-system/components/molecules/Modal/Modal.svelte";
  import CandidateAutocomplete from "../../components/CandidateAutocomplete.svelte";
  import { selectedCandidateIdStore } from "./stores";

  let { toDoId, onclose = () => {}, onclickAdd = () => {} } = $props();

  let candidateId = $state(null);

  const closeModal = () => {
    selectedCandidateIdStore.set(null);
    candidateId = null;
    onclose();
  };

  const addToCandidate = async () => {
    try {
      onclickAdd();
      await assignToDoContact({ toDoId, candidateId, kind: "aiToDo" });
      showToast({
        type: "success",
        title: "Successfully assigned to contact.",
      });
    } catch (error) {
      if (error instanceof ToastError) {
        showToast(error);
        return;
      }
      throw error;
    }
    closeModal();
  };

  // Getter and setter for candidateId to sync with store
  const getCandidateId = () => candidateId;
  const setCandidateId = (value) => {
    candidateId = value;
    selectedCandidateIdStore.set(value);
  };
</script>

<Modal closeButton={false} blur={true} onclose={closeModal}>
  <div slot="header" class="modal-header-content">
    <h2 class="title">Assign to a Contact</h2>
    <CloseButton
      onclose={closeModal}
      class="close-button"
      color="interfaceTransparentWhite_70"
      mouseEnterColor="interfaceTransparentWhite_50"
      focusColor="interfaceTransparentWhite_30"
    />
  </div>
  <div class="body">
    <CandidateAutocomplete
      bind:candidateId={getCandidateId, setCandidateId}
      style="width: 400px"
    />
  </div>
  <div class="footer">
    <Button size="large" class="flex-1" onclick={closeModal} kind="ghost-blue">
      Cancel
    </Button>
    <Button
      size="large"
      class="flex-1{$selectedCandidateIdStore ? '' : ' disabled'}"
      onclick={addToCandidate}
      disabled={!$selectedCandidateIdStore}
    >
      Add
    </Button>
  </div>
</Modal>
